import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Send, Loader2 } from 'lucide-react';
import api from '@/lib/api';
import { toast } from 'sonner';

export function EmailModal({ email, onClose }) {
  const [form, setForm] = useState({ subject: '', body: '' });
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (!form.subject || !form.body) { toast.error('Sujet et contenu requis'); return; }
    setSending(true);
    try {
      await api.post('/admin/send-email', { to_email: email, ...form });
      toast.success('Email envoye');
      onClose();
    } catch (err) { toast.error(err.response?.data?.detail || 'Erreur'); }
    finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white dark:bg-neutral-800 rounded-2xl border dark:border-neutral-700 w-full max-w-lg p-6" onClick={(e) => e.stopPropagation()} data-testid="email-modal">
        <h2 className="text-lg font-bold text-neutral-900 dark:text-white mb-1">Envoyer un email</h2>
        <p className="text-sm text-neutral-500 mb-4">Destinataire : <span className="font-medium text-neutral-700 dark:text-neutral-300">{email}</span></p>
        <div className="space-y-3">
          <Input placeholder="Sujet" value={form.subject} onChange={(e) => setForm(f => ({ ...f, subject: e.target.value }))} data-testid="email-subject" />
          <textarea className="w-full rounded-md border border-neutral-300 dark:border-neutral-600 bg-white dark:bg-neutral-700 px-3 py-2 text-sm min-h-[120px] resize-none focus:outline-none focus:ring-2 focus:ring-[#1F3F72] dark:text-white" placeholder="Contenu du message..." value={form.body} onChange={(e) => setForm(f => ({ ...f, body: e.target.value }))} data-testid="email-body" />
          <div className="flex gap-2 justify-end">
            <Button variant="ghost" onClick={onClose}>Annuler</Button>
            <Button className="bg-[#1F3F72] text-white" onClick={handleSend} disabled={sending} data-testid="email-send-btn">{sending ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Send className="w-4 h-4 mr-1" />} Envoyer</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
